<ion-header>
  <ion-toolbar color="secondary">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss(null)">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>AUSENCIA DEL CENTRO</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="aceptar()">
        <ion-icon slot="icon-only" name="checkmark-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-margin">
  <ion-list>
    <ion-radio-group #valor>
      <ion-list-header>
        <ion-label>ELIGE UNA RAZÓN:</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>VACACIONES</ion-label>
        <ion-radio slot="start" value="VACACIONES"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>CONJUNTIVITIS</ion-label>
        <ion-radio slot="start" value="CONJUNTIVITIS"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>DIARREA</ion-label>
        <ion-radio slot="start" value="DIARREA"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>FIEBRE</ion-label>
        <ion-radio slot="start" value="FIEBRE"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>GRIPE</ion-label>
        <ion-radio slot="start" value="GRIPE"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>OTITIS</ion-label>
        <ion-radio slot="start" value="OTITIS"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>VARICELA</ion-label>
        <ion-radio slot="start" value="VARICELA"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>VIRUS GASTROINTESTINAL</ion-label>
        <ion-radio slot="start" value="VIRUS GASTROINTESTINAL"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>VIRUS MANOS-PIES-BOCA</ion-label>
        <ion-radio slot="start" value="VIRUS MANOS-PIES-BOCA"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>OTRA ENFERMEDAD</ion-label>
        <ion-radio slot="start" value="OTRA ENFERMEDAD"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>OTRA RAZÓN</ion-label>
        <ion-radio slot="start" value="OTRA RAZÓN"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
